import React, { Component } from 'react'
import LeftNav from "../components/LeftNav"

import { ReactP5Wrapper } from "react-p5-wrapper";
import sketchScroll from '../components/SketchPredeterminateScroll';

export default class Predeterminate extends Component {
    render() {
        return(
            <div className="pageContainer">
                <LeftNav/>
                <div className="mainContent blackBg" style={{overflowY: "auto"}}>
                    <div>
                        <div className="collectionDiv" style={{padding: "20px 0px"}}>
                            <p className="collectionTitle" style={{padding: "0px 50px"}}>
                                Predeterminate, yet unknown
                            </p>
                            <a style={{padding: "0px 50px"}} href="https://verse.works/series/predeterminate-yet-unknown-by-michelangelo-encapsuled" target="_blank" rel="noopener noreferrer">
                                Sold out on verse
                            </a>
                            <p style={{padding: "0px 50px"}}>
                                Meaning<br/>
                                A human phenomenon, assigned to a set of perceptions composed together in a structure<br/>
                                an ontological reality, emerging from a complex system<br/>
                                a direction, an interpretation, a simplification, an explanation<br/>
                                for us to reduce complex in explainable<br/>
                                the result of a coin flip determined by an incalculable amount of forces acting on it<br/>
                                predeterminate, yet unknown<br/>
                                like a machine<br/>
                                like a nature made machine<br/>
                                like a human made machine<br/>
                                acting continuously<br/>
                                in observed independence,<br/>
                                in real dependence<br/>
                                an algorithm executing endlessly<br/>
                                predeterminate, yet unkown<br/>
                            </p>
                            <ReactP5Wrapper sketch={sketchScroll}/>
                            <br/><br/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}